module.exports = __webpack_public_path__ + "static/media/value-prop-icon-4.b1645efb.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/value-prop-icon-4.svg
// module id = 2663
// module chunks = 0